export default "__VITE_ASSET__BBTBSwKm__"